/*
 * Bulgarian strings for the interactive tools (Network Advisor, ROI
 * calculator, provisioning demo, hero mini pricer).
 *
 * Same idea as src/lib/network-map-i18n.ts: kept out of the global i18n
 * dictionary so that interface does not grow by several hundred keys.
 * Each catalogue maps the English UI string to its Bulgarian version and
 * the components keep their English literals, wrapped in tr(). A string
 * missing from a catalogue falls back to English, and
 * src/__tests__/tools-i18n.test.mjs fails (npm run test:map) when a
 * literal tr("...") call has no Bulgarian entry.
 *
 * REVIEW-BG: every Bulgarian string in this folder is a DRAFT written
 * during the visual QA pass (October 2026). It has not been reviewed by a
 * human translator or by sales/legal. Review before treating as final.
 */
import type { Language } from "@/lib/i18n";

export type Catalogue = Readonly<Record<string, string>>;

/** Returns tr(en) for the given language and catalogue. */
export function makeTr(lang: Language, catalogue: Catalogue): (en: string) => string {
  if (lang !== "bg") return (en) => en;
  return (en) => catalogue[en] ?? en;
}

/** Replace {name} placeholders after translation. */
export function fill(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (m, k: string) =>
    k in values ? String(values[k]) : m,
  );
}

/** Bulgarian PoP city names (REVIEW-BG). */
export const CITY_BG: Catalogue = {
  Sofia: "София",
  Frankfurt: "Франкфурт",
  Istanbul: "Истанбул",
  Athens: "Атина",
  London: "Лондон",
  Tbilisi: "Тбилиси",
  Dubai: "Дубай",
  Yerevan: "Ереван",
  Agarak: "Агарак",
  Plovdiv: "Пловдив",
  "Stara Zagora": "Стара Загора",
  Burgas: "Бургас",
  Varna: "Варна",
  Balchik: "Балчик",
  Dobrich: "Добрич",
  Montana: "Монтана",
  Pleven: "Плевен",
  Blagoevgrad: "Благоевград",
};
